import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import HeadTable from "../../common/sortTable/sortTable";
import TablesSearch from "../../common/tablesSearch/tablesSearch";
import { getDate } from "../../../helpers/dateHelper";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { Bonus } from "../../../types/bonus";
import PaginationTable from "../../common/paginationTable";

interface BonusesTableProps {
  bonuses: Array<Bonus>;
  handleSort: (direction: string, field: string) => void;
  search: (value: string, field: string) => void;
  applySearch: (field: string) => void;
  searchValue: string;
  clearSearch: () => void;
  handleShowModals: (
    modalName: "viewBonus" | "createEditBonus"
  ) => (bonusId: string | undefined) => void;
  page: number;
  perPage: number;
  collectionLength: number;
  total: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleLastPage: () => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFirstPage: () => void;
}

export const BonusesTable = ({
  bonuses,
  handleSort,
  search,
  applySearch,
  searchValue,
  clearSearch,
  handleShowModals,
  page,
  perPage,
  collectionLength,
  total,
  handleChangePage,
  handleLastPage,
  handleChangeRowsPerPage,
  handleFirstPage,
}: BonusesTableProps) => {
  const [dropdown, setDropdown] = useState({
    name: false,
    type: false,
    status: false,
    start: false,
    finish: false,
  });

  const filterDropdown = (title: string) => {
    setDropdown({ ...dropdown, [title]: !dropdown[title] });
  };

  const closeFilter = () => {
    setDropdown({
      name: false,
      type: false,
      status: false,
      start: false,
      finish: false,
    });
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key={1}>
                <HeadTable
                  title="Name"
                  sort={handleSort}
                  filterHandle={() => filterDropdown("name")}
                />
                {dropdown.name && (
                  <TablesSearch
                    search={(event) =>
                      search(event.currentTarget.value, "pageTitle")
                    }
                    applySearch={() => applySearch("pageTitle")}
                    searchString={searchValue}
                    clearSearch={() => clearSearch()}
                  />
                )}
              </TableCell>
              <TableCell>Price</TableCell>
              <TableCell>
                <HeadTable title="Start Date" sort={handleSort} />
              </TableCell>
              <TableCell>
                <HeadTable title="Finish Date" sort={handleSort} />
              </TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody onClick={closeFilter}>
            {!!bonuses.length &&
              bonuses.map((bonus) => {
                return (
                  <TableRow key={bonus._id}>
                    <TableCell>{bonus.pageTitle}</TableCell>
                    <TableCell>{bonus.price}</TableCell>
                    <TableCell>
                      {getDate(new Date(bonus.startAt), false)}
                    </TableCell>
                    <TableCell>
                      {getDate(new Date(bonus.endAt), false)}
                    </TableCell>
                    <TableCell>
                      {bonus.isActive ? "Active" : "Inactive"}
                    </TableCell>
                    <TableCell className="actions-table-cell">
                      <div className="actions-table-body">
                        <VisibilityIcon
                          onClick={() =>
                            handleShowModals("viewBonus")(bonus._id)
                          }
                          id="show-tickets"
                        />
                        <div
                          onClick={() =>
                            handleShowModals!("createEditBonus")(bonus._id)
                          }
                        >
                          <EditIcon className="delete-icon" />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationTable
        page={page}
        perPage={perPage}
        collectionLength={collectionLength}
        total={total}
        handleChangePage={handleChangePage}
        handleLastPage={handleLastPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleFirstPage={handleFirstPage}
        title="Bonuses"
      />
    </>
  );
};
